import React, { PureComponent } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import GridTitle from './GridTitle';

import './Grid.scss';

class Grid extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    block: PropTypes.bool,
    transparent: PropTypes.bool,
    nopadding: PropTypes.bool,
    nomargin: PropTypes.bool,
    noborder: PropTypes.bool,
    half: PropTypes.bool
  };

  render() {
    const {
      transparent,
      block,
      children,
      className,
      nopadding,
      nomargin,
      noborder,
      half,
      ...props
    } = this.props;
    const classComponent = classNames(
      'grid',
      {
        grid__nopadding: nopadding,
        grid__transparent: transparent,
        grid__block: block,
        grid__nomargin: nomargin,
        grid__noborder: noborder,
        grid__half: half
      },
      className
    );

    return (
      <div className={classComponent} {...props}>
        {children}
      </div>
    );
  }
}

Grid.Title = GridTitle;

export default Grid;
